import httpRequest from '../httpRequest'

/**
 * 自定义活动页
 *
 * ⚠ 走 src/api/，不要学 bannerList/index.vue 和 addBanner.vue 那样内联 this.axios
 *   并硬编码 https://time.api.boyalife.cn —— 那样写等于把生产域名钉死在页面里，
 *   开发环境调不动（commit fef364a 就是"两处二维码打错环境"）。
 *   这里的相对路径会由 config/server.js 按 .env 拼上对应环境的 baseURL。
 *
 * 响应已被 http.interceptor 剥到 data.result，所以下面每个方法拿到的就是后端
 * render(200, ['result' => ...]) 里的那个 result。
 */
export default {
  // 列表(筛选 + 分页)
  getList: {
    method: 'get',
    url: '/v1/cms/ActivityPage'
  },

  // 详情：页面 + 组件 + 每个组件下的图，都已按 sort 排好
  getDetail: {
    fn: uuid => httpRequest.get(`/v1/cms/ActivityPage/${uuid}`)
  },

  // 新建
  create: {
    method: 'post',
    url: '/v1/cms/ActivityPage'
  },

  // 编辑
  // ⚠ 是**整页替换**：后端会把旧的组件和图物理删掉再按 components 重建。
  //   只想改个标题也必须把原来的 components 原样带上，不带会被后端拒掉。
  update: {
    fn: (uuid, data) => httpRequest.put(`/v1/cms/ActivityPage/${uuid}`, data)
  },

  // 删除(软删)
  delete: {
    fn: uuid => httpRequest.delete(`/v1/cms/ActivityPage/${uuid}`)
  },

  // 上下架。status: 1上架 2未上架（全站约定是 1/2，不是 1/0）
  updateStatus: {
    fn: (uuid, data) => httpRequest.put(`/v1/cms/ActivityPage/status/${uuid}`, data)
  },

  // 小程序码，返回 { qrcode: 'data:image/png;base64,...' }
  getQrcode: {
    fn: uuid => httpRequest.get(`/v1/cms/ActivityPage/qrcode/${uuid}`)
  }
}
